import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

type Store = {
  encyclopediaListParams: {
    cusId: string | null,
    pageNum: number,
  },
  setEncyclopediaListParams: (name: any, value: any) => void,

  encyclopediaList: [],
  setEncyclopediaList: (by: []) => void,

  encyclopediaListCount: number,
  setEncyclopediaListCount: (by: number) => void,

  contentsInfo: Object,
  setContentsInfo: (by: Object) => void,

  clear: () => void,
  detailClear: () => void,
  /*  reservationId: string
    setReservationId: (by: string) => void*/
}

const useEncyclopediaStore = create<Store>()(
  devtools(
    persist(
      (set) => ({
        encyclopediaListParams: { cusId: localStorage.getItem('userCusID'), pageNum: 0 },
        setEncyclopediaListParams: (name: any, value: any) => set((state: any) => {
          state.encyclopediaListParams[name] = value;
          return {}
        }),

        encyclopediaList: [],
        setEncyclopediaList: (by: []) => set((state) => ({ encyclopediaList: by })),

        encyclopediaListCount: 0,
        setEncyclopediaListCount: (by: number) => set((state) => ({ encyclopediaListCount: by })),

        contentsInfo: {},
        setContentsInfo: (by: Object) => set((state) => ({ contentsInfo: by })),

        /*  reservationId: '',
          setReservationId: (by: string) => set((state) => ({ reservationId: by })),*/

        clear: () => set((state) => ({
          encyclopediaList: [],
          encyclopediaListParams: { cusId: localStorage.getItem('userCusID'), pageNum: 0 },
        })),

        detailClear: () => set((state) => ({
          contentsInfo: {},
        })),
      }),

      { name: 'encyclopediaStore' },
    ),
  ),
)

export default useEncyclopediaStore;
